module.exports = __webpack_public_path__ + "assets/img/22_1313_big.49bb19ea.jpg";